import { SpoTenant } from '../../../../../../../stores/client/powershell/spo/tenant/model';
import { updateSpoTenant } from '../../../../../../../stores/client/powershell/spo/tenant/actions';
import { OrgAnonymousLinksSharingPolicySchema } from '../../../../../../../../app/modules/sway/models/baseline-schemas/org-anonymous-links-sharing-policy';

export function Remediate(_tenant: string, data: Partial<SpoTenant>, schema: OrgAnonymousLinksSharingPolicySchema) {
    return updateSpoTenant({
        _tenant,
        data: {
            SharingCapability: schema.properties.SharingCapability.const,
            OneDriveSharingCapability: schema.properties.OneDriveSharingCapability.const,
            DefaultSharingLinkType: schema.properties.DefaultSharingLinkType.const,
            DefaultLinkPermission: schema.properties.DefaultLinkPermission.const,
            DisplayNamesOfFileViewersInSpo: schema.properties.DisplayNamesOfFileViewersInSpo.const,
            DisplayNamesOfFileViewers: schema.properties.DisplayNamesOfFileViewers.const,
            FolderAnonymousLinkType: schema.properties.FolderAnonymousLinkType?.const,
            FileAnonymousLinkType: schema.properties.FileAnonymousLinkType?.const,
        },
    });
}
